import * as React from "react";
import {
  Collapse,
  IconButton,
  List,
  ListItem,
  ListItemIcon,
  ListItemButton,
  ListItemText,
} from "@mui/material";
import ExpandLess from "@mui/icons-material/ExpandLess";
import ExpandMore from "@mui/icons-material/ExpandMore";

import SendIcon from "@mui/icons-material/Send";

import { useHistory } from "react-router-dom";
import { ProductData } from "./ProductData";

export default function SidebarItem({ value }) {
  const history = useHistory();

  const handleNav = (event) => {
    // Do whatever you need to do then push to the new page
    history.push(event);
  };

  const [open, setOpen] = React.useState(false);
  // open and close the collapse
  const handleClick = () => {
    setOpen(!open);
  };

  return (
    <div>
      <ListItem disablePadding sx={{ display: "block" }}>
        <ListItemButton
          sx={{
            minHeight: 48,
            px: 2.5,
          }}
          onClick={() => {
            handleNav(value.link);
            handleClick();
          }}
        >
          <ListItemIcon>
            <value.icon fontSize="small" />
          </ListItemIcon>
          <ListItemText
            primary={value.title}
            primaryTypographyProps={{ fontSize: "13px" }}
          />

          {value.subs ? (
            open ? (
              <ExpandLess fontSize="small" />
            ) : (
              <ExpandMore fontSize="small" />
            )
          ) : null}
        </ListItemButton>
      </ListItem>

      <Collapse in={open} timeout="auto" unmountOnExit>
        {value.subs ? (
          <List component="div" disablePadding>
            {value.subs.map((val, key) => (
              <ListItem sx={{ pl: 7 }} key={key} disablePadding>
                <ListItemButton onClick={() => handleNav(val.link)}>
                  <ListItemText
                    primary={val.title}
                    primaryTypographyProps={{ fontSize: "12px" }}
                  />
                </ListItemButton>
              </ListItem>
            ))}
          </List>
        ) : null}
      </Collapse>
    </div>
  );
}
